import i18n from "../i18n.js";
import { normalizeLanguage } from "../i18n.js";
import { enUS, es, ptBR } from "date-fns/locale";
import type { Locale } from "date-fns";

export function activeLocale(): string {
  return normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);
}

export function activeDateFnsLocale(): Locale {
  const locale = activeLocale();
  if (locale === "en") return enUS;
  if (locale === "es") return es;
  return ptBR;
}

export function formatDate(
  value: Date | string | number,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime())
    ? "—"
    : new Intl.DateTimeFormat(activeLocale(), options).format(date);
}

export function formatDateTime(value: Date | string | number): string {
  return formatDate(value, { dateStyle: "short", timeStyle: "short" });
}

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(activeLocale(), options).format(value);
}

export function formatCurrency(
  value: number,
  currency = "BRL",
  options?: Intl.NumberFormatOptions,
): string {
  return formatNumber(value, { style: "currency", currency, ...options });
}
